import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import getInitialActivityState from './initialState';

// Modules
import typing from './typing';

export default {
  namespaced: true,
  state: getInitialActivityState(),
  mutations,
  getters,
  actions,
  modules: {
    typing
  }
};
